import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { BaseComponent } from '../../base-component';
import { FirstHydroInstructionsGridDto } from 'src/app/core/Dtos/fhc-hydro/instructions-grid-dto';
import { AdHocInstructionsGridDTO } from 'src/app/core/Dtos/ad-hoc/instructions-grid-dto';
import { FhcInstructionsComponent } from '../grids/fhc-instructions/fhc-instructions.component';
import { DateFormatHelperService } from 'src/app/core/services/date-format-helper.service';
import { AlertsService } from 'src/app/core/services/alerts.service';
import { Router } from '@angular/router';
import { AdHocInstructionsService } from 'src/app/core/services/ad-hoc-instructions.service';
import { FhcHydroService } from 'src/app/core/services/fhc-hydro.service';
import { Assets } from 'src/app/core/Dtos/assets-enum';
import { TraderInstructionArgs } from '../../dashboards-viewer/trader-instruction-view-args';
import { OktaService } from '@engie-group/ngx-gem-spaas';

@Component({
  selector: 'app-fhc-dashboard',
  templateUrl: './fhc-dashboard.component.html',
  styleUrl: './fhc-dashboard.component.scss',
  standalone: false
})
export class FhcDashboardComponent extends BaseComponent{
  @Output() 
  public OnViewInstruction : EventEmitter<TraderInstructionArgs> = new EventEmitter<TraderInstructionArgs>();

  public SearchCurrentAndFuture: string = "ShowActiveAndFutrure";
  public SearchDateFrom: Date = new Date();
  public SearchDateTo: Date = new Date();

  public FHCIntructionsData: FirstHydroInstructionsGridDto[] = [];
  public FHCAdHocData: AdHocInstructionsGridDTO[] = [];
  public FHCLastRefresh: string = "";

  @ViewChild(FhcInstructionsComponent)
  _instructionsComponent: FhcInstructionsComponent | undefined;

  constructor(
    dateFormatHelper: DateFormatHelperService,
    oktaService: OktaService,
    alertService: AlertsService,
    private _router: Router,
    private _fhcHydroService: FhcHydroService,
    private _adHocService: AdHocInstructionsService) {
    super(oktaService, alertService, dateFormatHelper)
    // Load Moray West InstructionsF
    this.GetInstructions();
    this.SearchDateFrom.setMonth(this.SearchDateFrom.getMonth() - 1);
  }

  public GetInstructions() {
    if (this.SearchCurrentAndFuture == "ShowActiveAndFutrure") {
      this._fhcHydroService.GetActiveAndFutureInstructions().subscribe(
        resp => {
          this.FHCIntructionsData = resp;
          this.FHCLastRefresh = this.DateFormatHelper.GetDisplayDate(new Date());
        });
      this._adHocService.GetActiveAndFutureInstructions(Assets.FirstHydro).subscribe(
        resp => {
          this.FHCAdHocData = resp;
        }
      );
    }
    else {
      this._fhcHydroService.GetInstructionsByDateRange(this.SearchDateFrom, this.SearchDateTo).subscribe(
        resp => {
          this.FHCIntructionsData = resp;
          this.FHCLastRefresh = this.DateFormatHelper.GetDisplayDate(new Date());
        });
      this._adHocService.GetInstructionsByDateRange(Assets.FirstHydro, this.SearchDateFrom, this.SearchDateTo).subscribe(
        resp => {
          this.FHCAdHocData = resp;
        }
      );
    }
  }

  public SetDateTo(target: any) {
    this.SearchDateTo = target.valueAsDate;
  }
  public SetDateFrom(target: any) {
    this.SearchDateFrom = target.valueAsDate;
  }

  public AddNewInstruction() {
    this._router.navigate(["fhc-new"]);
  }

  public AddNewAdHocInstruction() {
    this._router.navigate(["fhc/adhoc-new"]);
  }
  
  public ViewInstruction(instructionId: string | number, isAdHoc:boolean) {
    this.OnViewInstruction?.next(new TraderInstructionArgs(Assets.FirstHydro, instructionId, isAdHoc));
  }
}
